module.exports = __webpack_public_path__ + "img/avatar-3.e7607dc8.jpg";